<div id="general" class="iw-container">
    <div class="static-component">
        <img src="assets/images/appAdd.webp">
        <a href="https://apps.apple.com/mx/app/ituran-con-seguro/id1509494944" target="_blank" class="appStore"></a>
        <a href="https://play.google.com/store/apps/details?id=com.ituran.seguros" target="_blank" class="playStore"></a>
    </div>
</div>
